<template>
  <div data-app>
    <div
      role="alert"
      v-bind:class="{ show: errors.length }"
      class="alert fade alert-danger"
    >
      <div class="alert-text" v-for="(error, i) in errors" :key="i">
        {{ error }}
      </div>
    </div>
    <v-card class="mb-5">
      <v-card-title>
        <span class="headline">Limits</span>
      </v-card-title>
      <v-card-text>
        <div role="alert" class="alert fade show alert-danger" v-if="limitsErrors.length">
          <div class="alert-text" v-for="(error, i) in limitsErrors" :key="i">
            {{ error }}
          </div>
        </div>
        <div v-if="loadingLimits" class="text-muted">Loading limits...</div>
        <v-row v-else dense>
          <v-col
            v-for="limit in visibleLimits"
            :key="limit.key"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card flat>
              <v-card-title class="text-h6">
                {{ limit.label }}
              </v-card-title>
              <v-card-text class="text-body-2">
                {{ formatLimit(limit.value) }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>
        <span class="headline">Change password</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="newForm" lazy-validation>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.oldPassword"
                  label="Old password*"
                  type="password"
                  :rules="required"
                  required
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.newPassword"
                  label="New password*"
                  type="password"
                  :rules="required"
                  required
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.newPasswordRepeated"
                  label="New password (repeated)*"
                  type="password"
                  :rules="[passwordConfirmationRule]"
                  required
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="save">Change password</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from "@/common/api.service";
import Errors from "@/common/errors";

export default {
  mounted() {
    this.fetchLimits();
  },

  data: () => ({
    errors: [],
    limitsErrors: [],
    loadingLimits: true,
    limits: {
      websites: null,
      waf_rules: null,
      rules: null,
      tunnels: null,
      prefixes: null,
    },
    editedItem: {
      oldPassword: null,
      newPassword: null,
      newPasswordRepeated: null,
    },
    required: [(v) => !!v || "Password is required"],
  }),

  methods: {
    fetchLimits() {
      this.loadingLimits = true;
      this.limitsErrors = [];
      api
        .query("/v2/limits")
        .then(({ data }) => {
          this.limits = {
            websites: data.websites,
            waf_rules: data.waf_rules,
            rules: data.rules,
            tunnels: data.tunnels,
            prefixes: data.prefixes,
          };
        })
        .catch((error) =>
          this.limitsErrors.push(...Errors.extractErrorMessage(error))
        )
        .finally(() => {
          this.loadingLimits = false;
        });
    },
    formatLimit(value) {
      if (value === null || value === undefined) return "N/A";
      if (typeof value !== "number" || Number.isNaN(value)) return value;

      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        maximumFractionDigits: 1,
      })
        .format(value)
        .toLowerCase();
    },
    save() {
      if (!this.$refs.newForm.validate()) return;

      api
        .post("/account/password", {
          old_password: this.editedItem.oldPassword,
          new_password: this.editedItem.newPassword,
        })
        .then((response) => this.errors.push("password updated successfuly"))
        .catch((error) => this.errors.push(...Errors.extractErrorMessage(error)));
    },
  },

  computed: {
    visibleLimits() {
      const items = [
        { key: "rules", label: "Rules", value: this.limits.rules },
        { key: "tunnels", label: "Tunnels", value: this.limits.tunnels },
      ];

      if (this.hasWaf) {
        items.push({
          key: "websites",
          label: "Websites",
          value: this.limits.websites,
        });
        items.push({
          key: "waf_rules",
          label: "WAF Rules",
          value: this.limits.waf_rules,
        });
      }

      if (this.canAnnouncePrefixes) {
        items.push({
          key: "prefixes",
          label: "Prefixes",
          value: this.limits.prefixes,
        });
      }

      return items;
    },
    hasWaf() {
      return !!this.$store.state.auth.user.has_waf;
    },
    canAnnouncePrefixes() {
      return !!this.$store.state.auth.user.can_announce_prefixes;
    },
    passwordConfirmationRule() {
      return () =>
        this.editedItem.newPassword === this.editedItem.newPasswordRepeated ||
        "Password must match";
    },
  },
};
</script>
